// extracted by mini-css-extract-plugin
module.exports = {"picture":"style__picture__N035t","youth":"style__youth__LPOmb","teen":"style__teen__mJke6","methodGrid":"style__methodGrid__lLt6O","info":"style__info__JMQp9"};